import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { getErrorCode, getErrorStatusCode } from "../../../../api/api-response";
import { RestEndpoints } from "../../../../api/endpoints";
import getInstance from "../../../../utils/rest";
import { CfmQueryKeys } from "../cfm-query-keys";

const deleteProductRoutingAssignment = async (id: number): Promise<void> => {
  await getInstance().delete(RestEndpoints.DeleteProductRoutingAssignment.replace(":id", id.toString()));
};

export const useDeleteProductRoutingAssignmentQuery = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id }: { id: number }) => deleteProductRoutingAssignment(id),

    onError: (error) => {
      const errorMsg = getErrorCode(error);
      const errorCode = getErrorStatusCode(error);
      enqueueSnackbar(t("general.error_occurred", { errorCode, errorMsg }), { variant: "error" });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [CfmQueryKeys.GetAllProducts] });
      queryClient.invalidateQueries({ queryKey: [CfmQueryKeys.GetAllProductsInfinite] });
      queryClient.invalidateQueries({ queryKey: [CfmQueryKeys.GetProductCount] });
    },
  });
};
